const ROUTE_CHANGE = 'route/';

export const ROUTE_SET = `${ROUTE_CHANGE}setRouteChange`;
export const ROUTE_GET = `${ROUTE_CHANGE}getRouteChange`;
export const ROUTE_FROM_SET = `${ROUTE_CHANGE}setRouteFrom`;
export const ROUTE_FROM_GET = `${ROUTE_CHANGE}getRouteFrom`;

export default {
  namespaced: true,
  state: {
    routeValue: {},
    routerTime: null,
    routeFrom: {},
  },
  mutations: {
    setRouteChange: (state, obj) => {
      state.routeValue = obj.value;
      state.routerTime = obj.time;
    },
    setRouteFrom: (state, fromRoute) => {
      state.routeFrom = fromRoute;
    },
  },
  actions: {},
  modules: {},
  getters: {
    getRouteChange(state) {
      return state.routeValue;
    },
    getRouteFrom(state) {
      return state.routeFrom;
    },
  },
};
